var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    { staticClass: "app" },
    [
      _c("OfflineLifecycle"),
      _c("RestoreCartItems"),
      _c("InhouseLifecycle"),
      _c("InventoryLifecycle"),
      _c("div", { attrs: { id: "background_wrap" } }, [
        _c("h1", { staticStyle: { opacity: "0" } }, [_vm._v("Tipsiolive")]),
      ]),
      _c(
        "div",
        { staticClass: "pwa", attrs: { id: "scrollTop" } },
        [
          _vm.$store.state.showSearch
            ? _c("div", { staticClass: "prelative" }, [_c("Search")], 1)
            : _vm._e(),
          _c("router-view"),
          _c("DialogBg"),
          _c(
            "v-overlay",
            {
              attrs: {
                value: _vm.$store.getters.showAddedOverlay,
                "z-index": "104",
              },
            },
            [
              _c(
                "div",
                { staticClass: "aoverlay text-center" },
                [
                  _c("div", { staticClass: "myDisplay1" }, [
                    _vm._v("Zum Korb hinzugefügt"),
                  ]),
                  _c("v-icon", { attrs: { dark: "", "x-large": "" } }, [
                    _vm._v("mdi-check"),
                  ]),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c("sidebar", {
        attrs: { drawer: _vm.drawer },
        on: {
          closeDrawer: function ($event) {
            _vm.drawer = false
          },
        },
      }),
      _c(
        "v-dialog",
        {
          attrs: { activator: "#foo", "max-width": "600", light: true },
          model: {
            value: _vm.infoDialog,
            callback: function ($$v) {
              _vm.infoDialog = $$v
            },
            expression: "infoDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("div", { staticClass: "spacer-15" }),
              _c(
                "div",
                { staticClass: "bigger-input line dialogText" },
                [
                  _c("v-card-title", { staticClass: "justify-center" }, [
                    _c("h3", {
                      staticClass: "text-center dialogText maxw",
                      domProps: { innerHTML: _vm._s(_vm.currentInfoTitle) },
                    }),
                  ]),
                  _vm.currentInfoImage.length > 0
                    ? _c(
                        "div",
                        { staticClass: "text-center" },
                        [
                          _c("div", { staticClass: "spacer-15" }),
                          _c("v-img", {
                            attrs: {
                              src: _vm.currentInfoImage,
                              contain: "",
                              position: "center center",
                              height: "200",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.currentInfoText.length > 0
                    ? _c("v-card-text", { staticClass: "bigger-line" }, [
                        _c("div", {
                          staticClass: "dialogText",
                          domProps: { innerHTML: _vm._s(_vm.currentInfoText) },
                        }),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "text-center justify-center" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "okBtn btn-df",
                      attrs: { rounded: "", large: "", text: "" },
                      on: { click: _vm.closeInfoDialog },
                    },
                    [_vm._v("OK")]
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "pb-3" }),
            ],
            1
          ),
        ],
        1
      ),
      _c("DsgvoDialog", {
        attrs: { dialog: _vm.showDsgvoDialog },
        on: {
          close: function ($event) {
            _vm.showDsgvoDialog = false
          },
        },
      }),
      _c("share-dialog", {
        attrs: { dialog: _vm.shareDialog },
        on: {
          close: function ($event) {
            _vm.shareDialog = false
          },
        },
      }),
      _c("question-dialog", {
        attrs: {
          dialog: _vm.questionDialog,
          question: _vm.currentQuestion,
          text: _vm.currentQtext,
          "yes-label": _vm.currentQYesLabel,
          "no-label": _vm.currentQNoLabel,
          biggerYesButton: _vm.biggerYesButton,
        },
        on: {
          close: function ($event) {
            _vm.questionDialog = false
            _vm.$ebus.$emit("questionClosed")
          },
          silentclose: function ($event) {
            _vm.questionDialog = false
          },
          yes: _vm.questionYes,
          no: _vm.questionNo,
        },
      }),
      _c("GangDialog", {
        attrs: {
          gang1: _vm.showG1,
          gang2: _vm.showG2,
          gang3: _vm.showG3,
          dialog: _vm.showGangDialog,
        },
        on: {
          silentclose: function ($event) {
            _vm.showGangDialog = false
          },
        },
      }),
      _c("pwa-promo-dialog", {
        attrs: { dialog: _vm.showInstallPromo },
        on: {
          close: function ($event) {
            _vm.showInstallPromo = false
          },
        },
      }),
      _c(
        "v-overlay",
        { attrs: { value: _vm.$store.state.showLoading, "z-index": "105" } },
        [
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "64" },
              }),
              _c("div", { staticClass: "myDisplay1" }, [_vm._v("LOADING")]),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _c(
            "v-bottom-sheet",
            {
              model: {
                value: _vm.showSheet,
                callback: function ($$v) {
                  _vm.showSheet = $$v
                },
                expression: "showSheet",
              },
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "d-flex justify-center",
                  attrs: { height: "200px" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "align-self-center text-center" },
                    [
                      _c("div", { staticClass: "mt-3 pa-3" }, [
                        _vm._v(" " + _vm._s(_vm.sheetText)),
                      ]),
                      _c(
                        "v-btn",
                        {
                          staticClass: "okBtn btn-df",
                          attrs: { rounded: "" },
                          on: {
                            click: function ($event) {
                              _vm.showSheet = false
                            },
                          },
                        },
                        [_vm._v(" OK ")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { top: true, "multi-line": "", timeout: _vm.snackTime },
          model: {
            value: _vm.showSnackbar,
            callback: function ($$v) {
              _vm.showSnackbar = $$v
            },
            expression: "showSnackbar",
          },
        },
        [
          _c(
            "v-layout",
            { staticClass: "flex-nowrap maxw", attrs: { row: "" } },
            [
              _c(
                "div",
                { staticClass: "align-self-center" },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: { color: "white", large: "" },
                    },
                    [_vm._v("mdi-information-variant")]
                  ),
                ],
                1
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "1.4em",
                    "line-height": "1.4em",
                    "margin-top": "3px",
                    "flex-grow": "1",
                  },
                },
                [_vm._v(_vm._s(_vm.snackText))]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "align-self-center",
                  attrs: { icon: "", color: "white" },
                  on: {
                    click: function ($event) {
                      _vm.showSnackbar = false
                    },
                  },
                },
                [_c("v-icon", [_vm._v("mdi-close-circle")])],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showInstallPromo && !_vm.$store.getters.inhouse
        ? _c("div", {
            staticClass: "pwa-overly",
            on: {
              "&click": function ($event) {
                return _vm.clickPwaOverlay.apply(null, arguments)
              },
            },
          })
        : _vm._e(),
      _c("AddDirectlyHandler"),
      _c("StempelLogic"),
      _c("div", { staticClass: "invisible all" }, [
        _vm._v(_vm._s(_vm.showDialogContainer)),
      ]),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", fullscreen: "", scrim: false },
          model: {
            value: _vm._showDialogContainer,
            callback: function ($$v) {
              _vm._showDialogContainer = $$v
            },
            expression: "_showDialogContainer",
          },
        },
        [
          _c("IframeOverlay", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm._showDialogContainer &&
                  _vm.$store.getters.secondSelectedDialog === "IframeOverlay",
                expression:
                  "_showDialogContainer && $store.getters.secondSelectedDialog === 'IframeOverlay'",
              },
            ],
          }),
          _c("Agb", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm._showDialogContainer &&
                  _vm.$store.getters.selectedDialog === "AGB",
                expression:
                  "_showDialogContainer && $store.getters.selectedDialog === 'AGB'",
              },
            ],
          }),
          _c("PaymentMethods", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm._showDialogContainer &&
                  _vm.$store.getters.selectedDialog === "PaymentMethods",
                expression:
                  "_showDialogContainer && $store.getters.selectedDialog === 'PaymentMethods'",
              },
            ],
          }),
          _c("TableQrCodeScanner", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm._showDialogContainer &&
                  _vm.$store.getters.selectedDialog === "TableQrCodeScanner",
                expression:
                  "_showDialogContainer && $store.getters.selectedDialog === 'TableQrCodeScanner'",
              },
            ],
          }),
          _vm._showDialogContainer &&
          _vm.$store.getters.selectedDialog === "RatingFeedback"
            ? _c("RatingFeedback")
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { position: "absolute", top: "0" } },
        [
          _c("div", { staticClass: "invisible all" }, [
            _vm._v(_vm._s(_vm.$store.getters.foodMenu)),
          ]),
          _c("Notification"),
          _c("GlobalsLifecycle"),
          _c("UserLifecycle"),
          _vm.$store.state.enableNews ? _c("NewsLifecycle") : _vm._e(),
          _vm.$store.state.enableFavs ? _c("FavoritesLifecycle") : _vm._e(),
          _c("GeopositionTool"),
          _c("PushTrigger"),
          _c("OrderModeSwitchDialog", {
            attrs: { dialog: _vm.showOrderModeSwitchDialog },
            on: {
              close: function ($event) {
                _vm.showOrderModeSwitchDialog = false
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }